import { render, staticRenderFns } from "./all-deals.vue?vue&type=template&id=3ba9144b&"
import script from "./all-deals.vue?vue&type=script&lang=js&"
export * from "./all-deals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports